<template>
  <div class="book-listen">
    <div class="listen-left">
      <img
        v-complete:src="props.info.image"
        alt=""
      />
      <div class="left-p">
        <p class="left-title"  @click="submitButton(info.id)">{{ info.title }}</p>
        <p>{{ info.create_time.slice(0, 10) }}</p>
        <!-- <div class="left-button">
          <el-tag
            type="info"
            v-for="(item, index) in props.info.tags"
            :key="index"
            >{{ item }}</el-tag
          >
    
        </div> -->
        <!-- <div class="left-box">
          <div>
            <el-icon><Calendar /></el-icon>
            <p>{{ info.create_time.slice(0, 10) }}</p>
          </div>
          <div class="box-line"></div>
          <div>
            <el-icon><View /></el-icon>
            <p>{{ info.views }}</p>
          </div>
          <div class="box-line"></div>
          <div>
            <el-icon><Download /></el-icon>
            <p>{{ info.downloads }}</p>
          </div>
          <div class="box-line"></div>
          <div>
            <el-icon><Document /></el-icon>
            <p>{{ info.exam_page }}</p>
          </div>
        </div> -->
      </div>
    </div>
    <div class="listen-right">
      <el-button
        v-if="props.info.is_collect === 0"
        @click="isCollect"
        class="add-favorites"
      >
        <el-icon><Star /></el-icon>
        <span>收藏</span>
      </el-button>
      <el-button v-else @click="isCollect" class="cancel-collection">
        <el-icon><Star /></el-icon>
        <span>收藏</span>
      </el-button>

      <el-button type="primary" @click="submitButton(info.id)">
        查看
      </el-button>
    </div>
  </div>
</template>

<script scoped setup>
import { Star } from "@element-plus/icons-vue";
import { Calendar } from "@element-plus/icons-vue";
import { View } from "@element-plus/icons-vue";
import { Download } from "@element-plus/icons-vue";
import { Document } from "@element-plus/icons-vue";

import { reactive } from "vue";
import { useRouter } from "vue-router";
import dayjs from "dayjs";
import { ElMessage, ElMessageBox } from "element-plus";

// 引入加入收藏、取消收藏接口
import {
  addFavoritesList,
  delFavoritesList,
} from "@/api/personalCenter/myCollection/index.js";

import { cancelCollect } from "@/api/addedServices/index.js";

const router = useRouter();

const mydata = reactive({
  path: "",
  // 基础地址
  VUE_APP_BASE_HOST: process.env.VUE_APP_BASE_HOST,
  userInfo: JSON.parse(localStorage.getItem("userInfo")) ?? {}, //用户信息
});

const props = defineProps({
  path: {
    type: String,
    // default: "",
  },
  info: {
    type: Object,
    default: () => {
      return {};
    },
  },
});

const emits = defineEmits("getListReload");

/**加入收藏/取消收藏的点击事件  0未收藏  1已收藏 */
function isCollect() {
  if (props.info.is_collect !== 0) {
    // 调用取消收藏接口
    cancelCollect(mydata.userInfo.jwt, {
      content_id: props.info.id,
      type: 1,
    }).then((res) => {
      ElMessage({
        message: res.msg,
        type: "success",
      });
      // 查询列表
      // init();
      emits("getListReload");
    });
  } else {
    // 调用加入收藏接口  类型(1:试卷,2:图书,3:文章,4:活动,5:视频)
    addFavoritesList(mydata.userInfo.jwt, {
      content_id: props.info.id,
      type: 1,
    }).then((res) => {
      ElMessage({
        message: res.msg,
        type: "success",
      });
      // 查询列表
      // init();
      emits("getListReload");
    });
  }
}

//按钮点击事件
function submitButton(id) {
  router.push({
    path: props.path,
    query: { id },
  });
}
</script>

<style scoped lang="scss">
.book-listen {
  width: 343px;
  height: 128px;
  border: 1px solid #eceef9;
  padding: 10px;
  border-radius: 4px;
  background-color: #ffffff;
  position:relative;
  // display: flex;
  // justify-content: space-between;
  // align-items: center;
  //////左边
  .listen-left {
    height: 68px;
    display: flex;
    // padding: 8px 0px 8px 8px;
    img {
      width: 68px;
      height: 68px;
      // margin-top: 12px;
    }
    .left-p {
      margin-left: 10px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      ////左边title
      .left-title {
        font-size: 14px;
        font-weight: 400;
        line-height: 22px;
        display: -webkit-box;
        -webkit-box-orient: vertical; // 从上向下垂直排列子元素。设置或检索伸缩盒对象的子元素的排列方式 。
        text-overflow: ellipsis; //文本溢出 用省略号显示
        -webkit-line-clamp: 2; //几行
        overflow: hidden;
        color: #333333;
        cursor: pointer;
      }
      .left-title:hover{
        color:#009DE0;
      }
      p:nth-of-type(2) {
        font-size: 12px;
        font-weight: 400;
        color: #999999;
      }
      /////左边按钮
      // .left-button {
      //   // border: 1px solid red;
      //   :deep(.el-tag.el-tag--info.el-tag--light) {
      //     border: 1px solid #c5cbce;
      //     background-color: #f0f5ff;
      //     border-radius: 4px;
      //     color: #333333;
      //     margin-right: 6px;
      //   }
      // }
      ////左边图标
      // .left-box {
      //   height: 21px;
      //   display: flex;
      //   align-items: center;
      //   // border: 1px solid blue;

      //   //每个小盒子
      //   > div {
      //     color: #9d9e9f;
      //     font-size: 12px;
      //     font-weight: 400;
      //     display: flex;
      //     :deep(.el-icon) {
      //       font-size: 14px;
      //       color: #9d9e9f;
      //       margin-top: 2px;
      //       margin-right: 3px;
      //     }
      //     > p {
      //       margin-top: 1px;
      //     }
      //   }
      //   .box-line {
      //     width: 1px;
      //     height: 13px;
      //     background-color: #e8e8e8;
      //     margin-left: 8px;
      //     margin-right: 8px;
      //   }
      // }
    }
  }

  //////右边
  .listen-right {
    width: 157px;
    height: 24px;
    display: flex;
    // justify-content: space-between;
    align-content: center;
    // border: 1px solid red;
    font-size: 14px;
    font-weight: 400;
    color: #333333;
    position:absolute;
    right:10px;
    bottom:20px;

    //两个button
    :deep(.el-button) {
      width: 96px;
      // height: 40px;
      margin-right: 10px;
      padding: 0px;
      border-radius: 8px;
      // width:auto;
      // padding: 0 10px;
      span {
        font-size: 14px;
        font-weight: 400;
        color: #333333;
      }
    }
    //收藏图标
    :deep(.el-icon) {
      font-size: 16px;
      color: #333333;
      margin-top:1px;
      // font-weight: 400px;
      // position: absolute;
      // top: -1px;
    }
    //加入收藏按钮
    :deep(.el-button.add-favorites) {
      > span {
        > span {
          margin-top: 2px;
          // color:red;
        }
      }
    }

    //取消收藏按钮
    :deep(.el-button.cancel-collection) {
      // border:1px solid red;
      // width:110px;
      > span {
        display: flex;
        align-items: center;
        .el-icon {
          // font-size: 20px;
          color: #ddaf77 !important;
          // font-weight: 400px;
          // position: absolute;
          // top: -1px;
        }
        > span {
          margin-top: 2px;
          color: #ddaf77 ;
        }
      }
    }
    //右边button
    :deep(.el-button.el-button--primary) {
      width: 96px;
      // height: 40px;
      margin: 0px;
      span {
        font-size: 14px;
        font-weight: 400;
        color: #ffffff;
      }
    }
  }
}
</style>
